import { shallowEqual, useSelector } from 'react-redux';
var useSelectedDispute = function () {
    return useSelector(function (_a) {
        var _b;
        var appConfig = _a.appConfig, disputes = _a.allDisputes.disputes;
        var _c = appConfig.selectedDispute, caseId = _c.caseId, transactionId = _c.transactionId;
        var selectedDispute = disputes.find(function (dispute) { return dispute.caseId === caseId; });
        var selectedTransaction = selectedDispute.transactions.find(function (transaction) { return transaction.id === transactionId; });
        var unsortedDisputeDocuments = ((_b = selectedTransaction.documentsUploaded) === null || _b === void 0 ? void 0 : _b.slice()) || [];
        var uploadedDisputeDocuments = unsortedDisputeDocuments.sort(function (a, b) { return Date.parse(b.uploadDate) - Date.parse(a.uploadDate); });
        return {
            selectedDispute: selectedDispute,
            selectedTransaction: selectedTransaction,
            uploadedDisputeDocuments: uploadedDisputeDocuments
        };
    }, shallowEqual);
};
export default useSelectedDispute;
//# sourceMappingURL=useSelectedDispute.js.map